import axios from 'axios';

const state = {
	address: Object,
};

const actions = {
	getAddress: ({ commit, rootState }, cep) => {
		return new Promise((resolve, reject)=>{
			axios.get(`//api2020vl.appcivico.com/api/cep?cep=${cep}`, { timeout: 10000 }).then((response)=>{
			resolve(response.data)
			commit('getAddressMutation', response.data)

			}).catch((err)=>{
				reject(err);
			})
		})
	}
};

const mutations = {
	getAddressMutation: (state, payload) => {
		state.address = payload
	}
};

export default {
	state,
	mutations,
	actions,
};



// WEBPACK FOOTER //
// ./_source/store/address/index.js